import { render } from "./Province.vue?vue&type=template&id=1ad6f9a1"
import script from "./Province.vue?vue&type=script&lang=js"
export * from "./Province.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__